export enum ErrorMessages {
  SORRY_SOMETHING_WENT_WRONG = 'Sorry, something went wrong',
  CONTACT_ADMIN = 'Please contact the system administrator',
}
